import '../../static/css/home/start.css';
import {Link} from "react-router-dom";
import {useEffect, useState} from "react";
import {HideMainLoading} from "../../components/template/architecture";
import {
    ThinAbsentIcon,
    ThinAdvertisingIcon,
    ThinArrowLeft,
    ThinBuildingIcon,
    ThinBusIcon,
    ThinCardIcon, ThinChevronRight, ThinConsentIcon, ThinCreditScoreIcon, ThinMenuBookIcon,
    ThinnerPeopleIcon,
    ThinnerSMSIcon, ThinPlayFillIcon,
    ThinStoreIcon
} from "../../components/icons/material-icons";
import {galleryItemInterface} from "./gallery/gallery";
import {PostJSON, ServerImage} from "../../components/api/webservice";
import {HomeInstagramComponent} from "./ig";
import {Apis} from "../../components/api/url";

export const HomeScreen = () => {
    useEffect(() => {
        document.title = "مدرسه مهارتی و هوشمند نهال";
        HideMainLoading();
    }, []);
    const [galleryList, setGalleryList] = useState<galleryItemInterface[]>([
        {
            title: 'تبریک سال نو توسط کادر نهال',
            isVideo: true,
            poster: '1404.jpg',
            video: 'https://video.nahalmaharat.ir/1404.mp4',
            showVideo: false,
        },
        {
            title: 'جلسه انجمن اولیا در هتل پارادایس',
            isVideo: true,
            poster: 'anjoman.jpg',
            video: 'https://video.nahalmaharat.ir/anjoman.mp4',
            showVideo: false,
        },
        {
            title: 'نه به تصادفات جاده ای',
            isVideo: true,
            poster: 'tasadof.jpg',
            video: 'https://video.nahalmaharat.ir/tasadof.mov',
            showVideo: false,
        },
        {
            title: 'نقشه گنج و جشن ضرب',
            isVideo: true,
            poster: 'gold.jpg',
            video: 'https://video.nahalmaharat.ir/gold.mov',
            showVideo: false,
        },
    ]);
    const [presignup, setPresignup] = useState(false);
    const fetchPresignupEnabled = () => {
        PostJSON(
            Apis.server + '/core/home/pres-status',
            {},
            false,
            (d: {
                result: string,
                reason: string,
                enable: boolean,
            }) => {
                if (d.result !== 'OK')
                    return;
                setPresignup(d.enable);
                HideMainLoading();
            },
            () => {
            },
            () => {
            },
        ).then(void 0);
    };
    useEffect(() => {
        fetchPresignupEnabled();
    }, []);
    return (
        <>
            <div data-aos="fade-up" data-aos-duration={1000}>
                <div className="welcome-hero">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <i>دبستان دخترانه مهارتی</i>
                                <h1>مدرسه مهارتی نهال</h1>
                                <p>مدرسه نهال اولین دبستان دخترانه با رویکرد مهارتی می‌باشد که واقع در شهرستان کاشمر
                                    می‌باشد. ما در دبستان نهال امید داریم که بتوانیم با ایجاد یک فضای مناسب و آموزش صحیح
                                    سهم مهمی در تربیت دانش‌آموزانمان داشته باشیم.</p>
                                <Link to="/students/overview" className="welcome-hero-cta">
                                    <span>ورود دانش‌آموزان</span>
                                    <ThinArrowLeft/>
                                </Link>
                                <br/>
                                <Link to="/admins/overview" className="welcome-hero-sec">
                                    <span>ورود کادر اداری</span>
                                    <ThinArrowLeft/>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    presignup ?
                        <div className="nahal-home-ad">
                            <div className="container">
                                {/*<div className="nahal-home-ad-underlay"/>*/}
                                <div className="nahal-home-ad-inside">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6 d-lg-none">
                                            <img style={{maxHeight: 250, marginBottom: 30}} src="/images/signup-ad.jpg"
                                                 alt="مدرسه نهال"/>
                                        </div>
                                        <div className="col-lg-6">
                                            <b>در نهال ثبت نام کنید!</b>
                                            <p>هم اکنون برای ثبت نام دانش‌آموز ابتدایی و یا پیش‌دبستانی خود در دبستان
                                                هوشمند و
                                                مهارتی نهال اقدام نمایید.</p>
                                            <Link to={"/signup"}>
                                                <span>ثبت نام</span>
                                                <ThinArrowLeft/>
                                            </Link>
                                        </div>
                                        <div className="col-lg-6 d-none d-lg-inline-block">
                                            <img src="/images/signup-ad.jpg" alt="مدرسه نهال"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : null
                }
                <div className="home-intro">
                    <div className="container-big">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <img src="/images/card-preview.jpg" alt="کارت های نهال"/>
                            </div>
                            <div className="col-lg-6">
                                <i>کارت هوشمند دانش‌آموزی</i>
                                <b>یک کارت، همه امکانات مدرسه هوشمند</b>
                                <p>کارت های دانش‌آموزی نهال که نوعی از کارت های هوشمند غیرتماسی می‌باشند به هر دانش‌آموز
                                    داده می‌شود و دانش‌آموزان می‌توانند با این کارت کارهایی از جمله خرید از بوفه،
                                    حضورغیاب همراه با ارسال پیامک و غیره را انجام دهند.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="home-features">
                    <div className="container-big">
                        <h2>برخی از امکانات سامانه</h2>
                        <p>فهرست برخی از مهم ترین امکانات این سامانه برای مدرسه نهال.</p>
                        <div className="row justify-content-center">
                            <div className="col-lg-3 col-md-6">
                                <div className="home-features-item">
                                    <i><ThinCreditScoreIcon/></i>
                                    <b>پرداخت آنلاین شهریه</b>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="home-features-item">
                                    <i><ThinStoreIcon/></i>
                                    <b>بوفه هوشمند و آنلاین</b>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="home-features-item">
                                    <i><ThinnerSMSIcon/></i>
                                    <b>پیامک ورود به مدرسه</b>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="home-features-item">
                                    <i><ThinConsentIcon/></i>
                                    <b>رضایت‌نامه آنلاین</b>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="home-features-item">
                                    <i><ThinCardIcon/></i>
                                    <b>کارت هوشمند دانش‌آموزی</b>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="home-features-item">
                                    <i><ThinAdvertisingIcon/></i>
                                    <b>اطلاعیه‌های آنلاین</b>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="home-features-item">
                                    <i><ThinAbsentIcon/></i>
                                    <b>حضورغیاب آنلاین</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{background: '#fff'}}>
                    <div className="container">
                        <div className="gallery-title">
                            <div>
                                <i/>
                                <em/>
                                <b>گالری نهال</b>
                            </div>
                            <Link to={"/gallery"}>
                                <span>مشاهده بیشتر</span>
                                <ThinArrowLeft/>
                            </Link>
                        </div>
                        <div className="row">
                            {
                                galleryList.map((m, i) =>
                                    <div className={"col-lg-4 col-6" + (i > 2 ? ' d-lg-none' : '')}
                                         key={"K8d_sSsjSjX" + i}>
                                        <div className="gallery-item">
                                            {
                                                m.showVideo ?
                                                    <video src={m.video}
                                                           controls={true}
                                                           autoPlay={true}
                                                           poster={ServerImage(m.poster)}
                                                    /> :
                                                    <>
                                                        <i style={{backgroundImage: `url(${ServerImage(m.poster)})`}}/>
                                                        <button onClick={() => setGalleryList(v => {
                                                            let x = [...v];
                                                            x[i].showVideo = true;
                                                            return x;
                                                        })}>
                                                            <ThinPlayFillIcon/>
                                                        </button>
                                                    </>
                                            }
                                            <b>{m.title}</b>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div style={{height: 50}}/>
                        <HomeInstagramComponent/>
                        <div style={{height: 80}}/>
                    </div>
                </div>
            </div>
        </>
    );
};